import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type TrendDir = 'up' | 'down' | 'flat' | null;

export interface CardStatItem {
  label: string;
  value: string;
  delta: string | null;
  trend: TrendDir;
}

/**
 * A compact stat strip: a flex row of KPI tiles, one per item.
 * Each tile renders value, label, and — when present — a delta badge
 * with trend arrow, using the same card-delta--* classes as card-metric.
 */
@Component({
  selector: 'card-stats',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-stats.component.html',
  styleUrls: ['./card-stats.component.scss'],
})
export class CardStatsComponent {
  @Input() title: string | null = null;
  @Input() items: CardStatItem[] = [];

  trendArrow(trend: TrendDir): string {
    if (trend === 'up') return '▲';
    if (trend === 'down') return '▼';
    return '—';
  }

  trendClass(trend: TrendDir): string {
    if (trend === 'up') return 'card-delta--up';
    if (trend === 'down') return 'card-delta--down';
    return 'card-delta--flat';
  }
}
